<div
  class="d-flex flex-column align-items-center h-100 w-100 justify-content-center px-4 py-4 modal-main"
>
  <div class="header mt-1 mb-5 w-100">
    <div class="d-flex justify-content-between">
      <img
        src="/assets/svg/ico-chevron-back-outline.svg"
        alt="back button"
        class="pointer-cursor"
        (click)="goBack()"
      />
      <h1 class="modal-title m-auto">{{ "USER_PROFILE" | translate }}</h1>
      <img
        src="/assets/svg/ico-hamburger-close.svg"
        class="cross-button pointer-cursor"
        (click)="closeDialog()"
      />
    </div>
  </div>

  <div class="mb-5">
    <p class="text-center heading-one">{{ "PHONE_NUMBER" | translate }}</p>
    <p class="paragraph-text text-center">
      {{ "PLEASE_ENTER_NEW_PHONE_NUMBER" | translate }}
    </p>
  </div>

  <div
    class="d-flex flex-column justify-content-start w-100 px-3 form-container"
  >
    <form [formGroup]="editPhoneForm">
      <div class="row">
        <div class="rounded-top col-3 form-field pr-2">
          <mat-form-field
            appearance="fill"
            class="bottom-zero mb-2 primary-input w-100"
          >
            <mat-label>{{ "ACCESS_DETAIL_REGION" | translate }}</mat-label>
            <input
              matInput
              placeholder="+1"
              formControlName="region"
              [(ngModel)]="regionValue"
              readonly
              class="gray-text"
            />
          </mat-form-field>
        </div>
        <div class="rounded-top form-field col-9">
          <mat-form-field appearance="fill" class="mb-2 primary-input w-100">
            <mat-label>{{ "ACCESS_DETAIL_PHONE" | translate }}</mat-label>
            <input
              matInput
              #phoneInputRef
              [placeholder]="'ACCESS_DETAIL_PHONE' | translate"
              formControlName="phone"
              type="text"
              [maxlength]="maxLength"
              id="phone"
              [value]="
                formInstance.phone.value
                  | phoneNumberFormat : formInstance.region.value
              "
              (click)="onRegionSelected(formInstance.region.value)"
              (keydown)="onInputBackSpace($event)"
            />
          </mat-form-field>
        </div>
      </div>
      <div class="row pl-2">
        <mat-error>
          <span *ngIf="formInstance.phone?.errors?.required">{{
            "ACCESS_DETAIL_PHONE_IS_REQURED" | translate
          }}</span>
          <span
            *ngIf="
              formInstance?.phone?.errors?.phone &&
              !formInstance.phone?.errors?.required
            "
            >{{ "WRONG_PHONE" | translate }}</span
          >
        </mat-error>
      </div>
      <div class="row pl-2">
        <mat-error>
          <span *ngIf="formInstance?.region?.errors?.required">{{
            "ACCESS_DETAIL_REGION_IS_REQURED" | translate
          }}</span>
          <span
            *ngIf="
              formInstance?.region?.errors?.region &&
              !formInstance?.region?.errors?.required
            "
            >{{ "WRONG_CODE" | translate }}</span
          >
        </mat-error>
      </div>
    </form>
  </div>

  <div class="row w-100 px-3">
    <div class="w-100">
      <button
        class="btn btn-danger update-btn px-3"
        [disabled]="!editPhoneForm.valid"
        (click)="onUpdate()"
      >
        {{ "UPDATE" | translate }}
      </button>
    </div>
  </div>
</div>
